import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-pv.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { BehaviorSubject, take, takeUntil } from "rxjs";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { MapService } from "../../../../../map/shared/map.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { CreateApplicationLocationPvConstants } from "./create-application-location-pv.constants";
import GeometryUtils from "../../../../../shared/utils/geometry-utils";
import Query from "@arcgis/core/rest/support/Query";
import Polygon from "@arcgis/core/geometry/Polygon";
import { MapTools } from "../../../../../map/shared/map.tools";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ValuationPropertyHeadingLookup } from "./property-heading-model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { EditPropertyDetailsPvConstants } from "./edit-property-details-pv/edit-property-details-pv.constants";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { SimulationUtils } from "src/app/shared/utils/simulation-utils";
let CreateApplicationLocationPvComponent = class CreateApplicationLocationPvComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    mapTools;
    modalService;
    requestStatusService;
    changeDetectorRefs;
    active;
    propertiesForm;
    propertyDetailsForm;
    properties;
    zoningsFromLookups = [];
    resetBlockLbl = CreateApplicationLocationPvConstants.RESET_BLOCK;
    descriptionLabel1 = CreateApplicationLocationPvConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationPvConstants.DESCRIPTION_LABEL_2;
    selectApplicationTypeError = CreateApplicationLocationPvConstants.WARNING_MESSAGE_NO_APPLICATION_TYPE;
    removeDialogTitle = CreateApplicationLocationPvConstants.REMOVE_DIALOG_TEXT;
    removePropertyContent = `${SharedConstants.REMOVE_MESSAGE} property(s)?`;
    editLabel = SharedConstants.EDIT_LABEL;
    deleteLabel = SharedConstants.DELETE_LABEL;
    saveLabel = "Update property";
    cancelLabel = SharedConstants.CANCEL_LABEL;
    propertyLayer;
    ownerLayer;
    zoningLayer;
    blockLayer;
    sgCodeZoneLookup = new Map();
    salesAreasLayerName = "New sales areas";
    newValuationBlockLayerName = "New valuation block";
    salesAreasPropertyLayerName = "New sales areas properties";
    newValuationBlockPropertyLayerName = "New valuation block properties";
    valuationBlockLayerName = "Valuation block";
    propertyLayerName = "Valuation block properties";
    ownerLayerName = "Property owners";
    selectedPropertyLayerName = "Selected properties";
    drawToolLayer = "Draw Tool Layer";
    blockConst = "block";
    salesAreaConst = "salesArea";
    showImportParameters = false;
    showMap = true;
    tableDataSource = [];
    tableMapper;
    createLookupsSubscription;
    valuationMethod;
    propertyType;
    selectedItemName = "";
    propertyToEdit = false;
    numProps = 0;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneItemMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    selectedPropertyDetails = null;
    selectedOwnerDetails = null;
    ownerGroups = [];
    propertyTypesOptions = [];
    categoriesFromLookups = [];
    drawingSalesArea = false;
    drawingBlock = true;
    reshaping = false;
    defaultSymbol = {
        type: "simple-fill",
        color: [85, 172, 63],
        style: "none",
        outline: {
            color: [85, 172, 63],
            width: 2
        },
        width: 2
    };
    saleAreaSymbol = {
        type: "simple-fill",
        color: [76, 136, 228],
        style: "none",
        outline: {
            color: [76, 136, 228],
            width: 2
        },
        width: 2
    };
    blockSymbol = {
        type: "simple-fill",
        color: [255, 0, 0],
        style: "none",
        outline: {
            color: [255, 0, 0],
            width: 2
        },
        width: 2
    };
    propertySelectionLayerNotConfigured = CreateApplicationLocationPvConstants.NO_PROPERTY_SELECTION_LAYER;
    zoneSelectionLayerNotConfigured = CreateApplicationLocationPvConstants.NO_ZONE_SELECTION_LAYER;
    selectedSymbol = {
        type: "simple-fill",
        color: [85, 172, 63],
        style: "none",
        outline: {
            color: [85, 172, 63],
            width: 2
        },
        width: 2
    };
    isMapLoaded = false;
    mapComponent;
    sketch;
    sketchGraphic = null;
    subscriptionToBlock;
    countSubscription = 0;
    categoryFilterString = "";
    subscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, mapService, mapTools, modalService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.modalService = modalService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.drawingBlock = true;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.propertyTypesOptions = defaults.propertyTypesOptions;
            this.updateDefinitionExpression();
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("propertyTypes") && this.aflaModuleStrategyService.lookups.has("Zoning")) {
                this.propertyTypesOptions = this.aflaModuleStrategyService.lookups.get("propertyTypes");
                this.zoningsFromLookups = this.aflaModuleStrategyService.lookups.get("Zoning");
                this.updateDefinitionExpression();
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initializeColumnToObjectMapping();
        this.setShowMap();
        this.initForm();
        this.drawingBlock = true;
        this.drawingSalesArea = false;
        this.subscribeToBlock();
    }
    subscribeToBlock() {
        this.subscription = this.mapService.$selectedBlock.subscribe((block) => this.addBlock(block));
    }
    ngAfterViewInit() {
        const chkBlock = document.getElementById(this.blockConst);
        const chkSalesArea = document.getElementById(this.salesAreaConst);
        if (chkBlock) {
            chkBlock.checked = true;
        }
        if (chkSalesArea) {
            chkSalesArea.checked = false;
        }
        this.drawingBlock = true;
        this.drawingSalesArea = false;
    }
    ngOnDestroy() {
        // this.subscriptionToBlock.unsubscribe();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        if (Object.prototype.hasOwnProperty.call(this.ownerGroups[0], "requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    blockSelected(event) {
        if (event.currentTarget.value === this.salesAreaConst) {
            this.drawingSalesArea = true;
            this.drawingBlock = false;
        }
        else if (event.currentTarget.value === this.blockConst) {
            this.drawingSalesArea = false;
            this.drawingBlock = true;
        }
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries(true, true);
        this.mapService.actionPropertyEnabled = false;
        this.mapService.actionPropertyOwnerEnabled = false;
        this.mapService.actionBlockEnabled = true;
        this.mapService.onSelectBlock = () => {
            this.showImportParameters = true;
            this.changeDetectorRefs.detectChanges();
        };
        this.mapService.addBlock = (b) => this.addBlock(b);
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.propertyLayer = this.mapService.userMaps.find(a => a.selectionLayerType.toLowerCase() === "property").layer;
        this.zoningLayer = this.mapService.userMaps.find(a => a.selectionLayerType.toLowerCase() === "property zone").layer;
        this.ownerLayer = this.mapService.userMaps.find(a => a.selectionLayerType.toLowerCase() === "property owner")?.layer;
        this.blockLayer = this.mapService.userMaps.find(a => a.selectionLayerType.toLowerCase() === "block")?.layer;
        this.blockLayer.popupEnabled = true;
        this.updateDefinitionExpression();
        this.mapTools.expandWidget("drawTool");
        this.sketch.on("update", (event) => {
            this.sketchUpdateAction(event);
        });
        this.sketch.duplicate();
        this.sketch.create("polygon");
        this.sketch.on("create", (event) => {
            this.sketchCreateAction(event);
        });
        this.changeDetectorRefs.detectChanges();
    }
    sketchUpdateAction(event) {
        if (event.state === "start") {
            this.showImportParameters = false;
        }
        if (event.state === "complete") {
            if (event.graphics[0].geometry.type === "polygon") {
                this.removeExistingProperties();
                const symbolsAndLayers = this.selectSymbolsAndLayers();
                if (this.sketchGraphic.attributes) {
                    const attributes = JSON.parse(JSON.stringify(this.sketchGraphic.attributes));
                    this.sketchGraphic = event.graphics[0];
                    this.sketchGraphic.attributes = attributes;
                }
                this.sketch.update([this.sketchGraphic], {
                    tool: "reshape",
                    enableRotation: true,
                    enableScaling: true,
                    preserveAspectRatio: true,
                    toggleToolOnClick: false
                });
                this.reshaping = true;
                this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.sketchGraphic.geometry)], symbolsAndLayers.layerName, false, false, symbolsAndLayers.symbols);
                this.getPropertiesInPropertyLayer();
            }
        }
    }
    removeExistingProperties() {
        // alert(this.drawingSalesArea+"fff"+ this.drawingBlock)
        // if(this.propertiesForm.get(CreateApplicationLocationPvConstants.SALES_AREA_PROPERTIES).value && this.drawingSalesArea){
        //   this.propertiesForm.get("tableSelection").setValue(this.propertiesForm.get(CreateApplicationLocationPvConstants.SALES_AREA_PROPERTIES).value);
        //   this.removePropertiesAfterDraw();
        //   this.propertiesForm.get(CreateApplicationLocationPvConstants.SALES_AREA_PROPERTIES).setValue(null);
        // }
        // if(this.propertiesForm.get(CreateApplicationLocationPvConstants.VALUATION_BLOCK_PROPERTIES).value && this.drawingBlock){
        //   this.propertiesForm.get("tableSelection").setValue(this.propertiesForm.get(CreateApplicationLocationPvConstants.VALUATION_BLOCK_PROPERTIES).value);
        //   this.removePropertiesAfterDraw();
        //   this.propertiesForm.get(CreateApplicationLocationPvConstants.VALUATION_BLOCK_PROPERTIES).setValue(null);
        // }
    }
    selectSymbolsAndLayers() {
        let layerName = this.valuationBlockLayerName;
        let symbols = this.defaultSymbol;
        let propertyLayerName = this.propertyLayerName;
        this.mapTools.sketchGraphicsLayer.removeAll();
        this.mapComponent.clearGraphics(this.valuationBlockLayerName);
        this.mapComponent.clearGraphics(this.selectedPropertyLayerName);
        this.mapComponent.clearGraphics(this.propertyLayerName);
        if (this.drawingSalesArea) {
            this.mapComponent.clearGraphics(this.salesAreasLayerName);
            this.mapComponent.clearGraphics(this.salesAreasPropertyLayerName);
            layerName = this.salesAreasLayerName;
            symbols = this.saleAreaSymbol;
            propertyLayerName = this.salesAreasPropertyLayerName;
        }
        else if (this.drawingBlock) {
            this.mapComponent.clearGraphics(this.newValuationBlockLayerName);
            this.mapComponent.clearGraphics(this.newValuationBlockPropertyLayerName);
            layerName = this.newValuationBlockLayerName;
            symbols = this.blockSymbol;
            propertyLayerName = this.newValuationBlockPropertyLayerName;
        }
        return { symbols, layerName, propertyLayerName };
    }
    sketchCreateAction(event) {
        if (event.state === "start") {
            this.mapService.showPopups = false;
            this.showImportParameters = false;
            if (!this.drawingBlock && !this.drawingSalesArea) {
                this.drawingBlock = true;
            }
        }
        if (event.state === "complete") {
            if (!this.drawingBlock && !this.drawingSalesArea) {
                this.appController.showMessage("You need to select either Draw sales are or Draw valuation block option before you can proceed.", AlertType.Warning);
                this.mapTools.sketchGraphicsLayer.remove(event.graphic);
                return;
            }
            this.mapService.showPopups = true;
            if (event.graphic.geometry.type === "polygon" || event.graphic.geometry.type === "polyline") {
                this.sketchGraphic = event.graphic;
                this.removeExistingProperties();
                const symbolsAndLayers = this.selectSymbolsAndLayers();
                this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.sketchGraphic.geometry)], symbolsAndLayers.layerName, true, false, symbolsAndLayers.symbols);
                // Query the zoning layer to find properties in the polygon with the correct zoning/property type
                this.getPropertiesInPropertyLayer();
            }
        }
        else if (event.state === "cancel") {
            this.mapService.showPopups = true;
        }
    }
    addBlock(block) {
        const chkBlock = document.getElementById(this.blockConst);
        chkBlock.checked = true;
        const chkSalesArea = document.getElementById(this.salesAreaConst);
        chkSalesArea.checked = false;
        if (this.drawingBlock === false && this.drawingSalesArea === false) {
            chkBlock.checked = true;
            chkSalesArea.checked = false;
            this.drawingBlock = true;
            this.drawingSalesArea = false;
        }
        this.showImportParameters = false;
        if (block == null)
            return;
        this.getCurrentBlockInBlockLayer(block);
        if (block.geometry.type === "polygon") {
            this.sketchGraphic = block;
            this.removeExistingProperties();
            const symbolsAndLayers = this.selectSymbolsAndLayers();
            this.mapComponent.clearGraphics(this.valuationBlockLayerName);
            this.mapComponent.clearGraphics(this.selectedPropertyLayerName);
            this.mapComponent.clearGraphics(this.propertyLayerName);
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.sketchGraphic.geometry)], this.drawToolLayer, true, false, symbolsAndLayers.symbols);
            this.reshaping = true;
            // Query the zoning layer to find properties in the polygon with the correct zoning/property type
            this.getPropertiesInPropertyLayer();
        }
    }
    getCurrentBlockInBlockLayer(block) {
        const blockJobId = this.propertyDataAlternateColumnName(block.attributes, "JobID", "jobid");
        const params = {
            $filter: `jobId eq ${blockJobId}`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe(x => {
            const application = x.value[0];
            this.propertiesForm.get("parentBlockId").setValue(application.id);
        });
    }
    tableItemSelected(array) {
        this.propertiesForm.get("tableSelection").setValue(array);
        if (this.propertiesForm.get("tableSelection").value.length > 0) {
            this.showPropertyDetails();
        }
        const geomArray = [];
        array.forEach(sel => {
            const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(sel.shape, 102100));
            geomArray.push(GeometryUtils.mapGeometryToDTO(geom));
        });
        if (this.mapComponent && this.mapComponent.mapLoaded) {
            this.mapComponent.addGeometriesOnMap((geomArray), this.selectedPropertyLayerName, true, false, this.selectedSymbol);
        }
    }
    getLookups() {
        const lookupParams = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID}  and (name eq 'PropertyType' or name eq 'Zoning')`
        };
        this.createLookupsSubscription = this.createApplicationService.getLookupsObservable(lookupParams).subscribe({
            next: response => {
                this.onGetLookupsCompleted(response);
            },
            error: error => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationPvConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const propertyTypes = [];
        const zones = [];
        if (response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "PropertyType") {
                    propertyTypes.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("propertyTypes", propertyTypes);
        this.propertyTypesOptions = propertyTypes;
        this.aflaModuleStrategyService.lookups.set("Zoning", zones);
        this.zoningsFromLookups = zones;
        this.updateDefinitionExpression();
    }
    updateDefinitionExpression() {
        if (this.propertyType) {
            const categories = [];
            let searchNull = false;
            this.propertyTypesOptions.forEach(item => {
                if (item.code === this.propertyType) {
                    if (item.code.toLowerCase() === "no category information" || item.value.toLowerCase() === "no category information"
                        || item.value.toLowerCase() === "null" || item.value.toLowerCase() === "") {
                        searchNull = true;
                    }
                    else {
                        categories.push("'" + item.value + "'");
                    }
                }
            });
            this.categoriesFromLookups = categories;
            this.categoryFilterString = "";
            if (categories.length > 0) {
                this.categoryFilterString = "ZoningCategory in (" + categories.join(",") + ")";
            }
            if (searchNull) {
                if (this.categoryFilterString !== "") {
                    this.categoryFilterString += " or ";
                }
                this.categoryFilterString += `ZoningCategory is null`;
            }
            if (this.propertyLayer != null) {
                this.propertyLayer.definitionExpression = this.categoryFilterString;
            }
        }
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.properties = this.aflaModuleStrategyService.form.get("propertiesForm").get("properties");
        this.propertiesForm.get("importParentAttributesParameters").setValue(false);
        this.propertiesForm.addControl("dataSource", new FormControl(new BehaviorSubject([])));
        this.propertiesForm.addControl("tableSelection", new FormControl(null));
        this.propertyDetailsForm = new FormGroup({
            editIndex: new FormControl(null),
            sgCodeEdit: new FormControl(null),
            portionNumberEdit: new FormControl(null),
            allotmentEdit: new FormControl(null),
            zoningEdit: new FormControl(null),
            descriptionEdit: new FormControl(null),
            addressEdit: new FormControl(null),
            erfNumberEdit: new FormControl(null),
            farmNumberEdit: new FormControl(null),
            unitNumberEdit: new FormControl(0),
            erfSizeEdit: new FormControl(0),
            ownersEdit: new FormControl(null)
        });
    }
    updatePropertyDetailsValidation() {
        this.propertyDetailsForm.clearValidators();
        const sgCodeControl = this.propertyDetailsForm.get("sgCodeEdit");
        const addressControl = this.propertyDetailsForm.get("addressEdit");
        const ownersControl = this.propertyDetailsForm.get("ownersEdit");
        const erfNoControl = this.propertyDetailsForm.get("erfNumberEdit");
        const farmNoControl = this.propertyDetailsForm.get("farmNumberEdit");
        const erfSizeControl = this.propertyDetailsForm.get("erfSizeEdit");
        const portionNumControl = this.propertyDetailsForm.get("portionNumberEdit");
        ownersControl.addValidators(Validators.required);
        addressControl.addValidators(Validators.required);
        sgCodeControl.addValidators(Validators.required);
        erfSizeControl.addValidators([Validators.required, Validators.min(0.1)]);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.addValidators(Validators.required);
            farmNoControl.clearValidators();
            farmNoControl.setValue("");
            farmNoControl.disable();
            farmNoControl.markAsUntouched();
        }
        else if (farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") {
            erfNoControl.clearValidators();
            farmNoControl.addValidators(Validators.required);
            portionNumControl.addValidators(Validators.required);
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.addValidators(Validators.required);
            farmNoControl.addValidators(Validators.required);
            portionNumControl.addValidators(Validators.required);
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            erfNoControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        sgCodeControl.updateValueAndValidity();
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        ownersControl.updateValueAndValidity();
        erfNoControl.updateValueAndValidity();
        portionNumControl.updateValueAndValidity();
    }
    getPropertiesInPropertyLayer() {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        const sgCodeArray = [];
        this.sgCodeZoneLookup.clear();
        this.selectedOwnerDetails = null;
        this.selectedPropertyDetails = null;
        const propertyQuery = new Query();
        propertyQuery.returnGeometry = true;
        propertyQuery.outFields = ["*"];
        propertyQuery.where = this.categoryFilterString;
        propertyQuery.spatialRelationship = "contains";
        propertyQuery.geometry = this.sketchGraphic.geometry;
        this.propertyLayer.queryFeatures(propertyQuery).then((propFeatures) => {
            this.properties.clear();
            if (propFeatures.features.length > 0) {
                propFeatures.features.forEach((feat) => {
                    const sgCode = this.propertyDataAlternateColumnName(feat.attributes, "SgCode", "sgcode");
                    sgCodeArray.push(sgCode);
                });
                this.selectedPropertyDetails = propFeatures;
                if (this.ownerLayer !== undefined && this.ownerLayer !== null) {
                    const ownerQuery = new Query();
                    ownerQuery.returnGeometry = false;
                    ownerQuery.outFields = ["*"];
                    ownerQuery.where = "SgCode in ('" + sgCodeArray.join("','") + "')";
                    this.ownerLayer.queryFeatures(ownerQuery).then((ownerFeatures) => {
                        this.requestStatusService.removeBusySpinner("GetPropertyData");
                        this.selectedOwnerDetails = ownerFeatures;
                        this.getZones(sgCodeArray);
                    }, (error) => {
                        this.requestStatusService.removeBusySpinner("GetPropertyData");
                        this.appController.handleServerErrorMessage(CreateApplicationLocationPvConstants.STEP_TITLE, error, CRUDOperation.Get);
                    });
                }
                else {
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                    this.getZones(sgCodeArray);
                }
            }
            else {
                this.requestStatusService.removeBusySpinner("GetPropertyData");
                this.appController.showMessage(`No properties of type ${this.propertyType} found within the polygon drawn`, AlertType.Warning);
            }
        }, (error) => {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            this.appController.handleServerErrorMessage(CreateApplicationLocationPvConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    getZones(sgCodeArray) {
        this.sgCodeZoneLookup.clear();
        // Query the zoning layer to find properties in the polygon with the correct zoning/property type
        const query = new Query();
        query.returnGeometry = false;
        query.where = "SgCode in ('" + sgCodeArray.join("','") + "')";
        query.outFields = ["*"];
        if (this.sketchGraphic.attributes)
            this.getCurrentBlockInBlockLayer(this.sketchGraphic);
        this.zoningLayer.queryFeatures(query).then((featureSet) => {
            if (featureSet.features.length > 0) {
                featureSet.features.forEach((feat) => {
                    const sgCode = this.propertyDataAlternateColumnName(feat.attributes, "SgCode", "sgcode");
                    const zone = this.propertyDataAlternateColumnName(feat.attributes, "Zoning", "zoning");
                    sgCodeArray.push(sgCode);
                    this.sgCodeZoneLookup.set(sgCode, zone);
                });
            }
            this.setProperties();
        }, (error) => {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            this.appController.showMessage(error.message, AlertType.Error);
            this.setProperties();
        });
    }
    setBlocksProperties(propArray) {
        if (this.drawingSalesArea) {
            this.propertiesForm.get("salesAreaShape").setValue(this.sketchGraphic.geometry.toJSON());
            this.propertiesForm.setControl("salesAreaProperties", new FormControl(propArray));
        }
        else {
            this.propertiesForm.get("shape").setValue(this.sketchGraphic.geometry.toJSON());
            if (!this.propertiesForm.get("salesAreaShape").value)
                this.propertiesForm.get("salesAreaShape").setValue(this.sketchGraphic.geometry.toJSON());
            this.propertiesForm.setControl("valuationBlockProperties", new FormControl(propArray));
        }
    }
    setProperties() {
        const propArray = [];
        if (this.drawingBlock)
            this.propertiesForm.setControl("dataSource", new FormControl(new BehaviorSubject([])));
        if (this.selectedPropertyDetails.features.length > 0) {
            this.selectedPropertyDetails.features.forEach((feat) => {
                const attr = feat.attributes;
                const geom = feat.geometry;
                const sgCode = this.propertyDataAlternateColumnName(attr, "SgCode", "sgcode");
                const zoning = this.sgCodeZoneLookup.has(sgCode) ? this.sgCodeZoneLookup.get(sgCode) : "";
                const selectedPropertyOwners = this.getOwnersForProperties(this.selectedOwnerDetails, sgCode);
                try {
                    const prop = {
                        id: +this.propertyDataAlternateColumnName(attr, "OBJECTID", "objectid") * -1,
                        sgCode,
                        address: this.propertyDataAlternateColumnName(attr, "Address", "address"),
                        allotment: this.propertyDataAlternateColumnName(attr, "Allotment", "allotment"),
                        zoning,
                        erfSize: this.propertyDataAlternateColumnName(attr, "ErfSize", "erfsize"),
                        farmNumber: this.propertyDataAlternateColumnName(attr, "FarmNo", "farmno"),
                        erfNumber: this.propertyDataAlternateColumnName(attr, "ErfNo", "erfno"),
                        subdivision: this.propertyDataAlternateColumnName(attr, "PtnNum", "ptnnum"),
                        unitNumber: this.propertyDataAlternateColumnName(attr, "UnitNumber", "unitnumber"),
                        description: this.propertyDataAlternateColumnName(attr, "PropertyDescription", "propertydescription"),
                        owners: selectedPropertyOwners,
                        deleted: false,
                        shape: WktConverterUtils.ConvertArcGISJsonToWkt(geom.toJSON()),
                        wkid: 102100,
                    };
                    const index = propArray.findIndex(x => x.id === prop.id);
                    if (index === -1)
                        propArray.push(prop);
                }
                catch {
                    this.requestStatusService.removeBusySpinner("GetPropertyData");
                    this.appController.showMessage(CreateApplicationLocationPvConstants.INVALID_PROPERTY_ATTRIBUTE, AlertType.Error);
                }
            });
            this.setBlocksProperties(propArray);
            if (this.drawingBlock) {
                const tableDataSource = this.propertiesForm.get("dataSource").value;
                const tableItems = [];
                propArray.forEach(property => {
                    const index = tableItems.findIndex(x => x.id == property.id);
                    if (index === -1)
                        tableItems.push(property);
                });
                tableDataSource.next(tableItems);
            }
            try {
                this.syncMapGeometries(true, false);
                this.changeDetectorRefs.detectChanges();
                this.requestStatusService.removeBusySpinner("GetPropertyData");
            }
            catch (err) {
                this.requestStatusService.removeBusySpinner("GetPropertyData");
                this.appController.showMessage(err, AlertType.Error);
            }
        }
        else {
            this.requestStatusService.removeBusySpinner("GetPropertyData");
            this.appController.showMessage("No properties found within the polygon drawn", AlertType.Warning);
        }
        this.changeDetectorRefs.detectChanges();
    }
    getOwnersForProperties(data, sgCode) {
        const ownerFeatures = data;
        const propertyOwners = [];
        ownerFeatures.features.forEach(item => {
            const ownerSgCode = this.propertyDataAlternateColumnName(item.attributes, "SgCode", "sgcode");
            if (ownerSgCode === sgCode) {
                try {
                    const newOwner = {
                        name: this.propertyDataAlternateColumnName(item.attributes, "Name", "name"),
                        surname: this.propertyDataAlternateColumnName(item.attributes, "Surname", "surname"),
                        telephone: this.propertyDataAlternateColumnName(item.attributes, "Telephone", "telephone"),
                        email: this.propertyDataAlternateColumnName(item.attributes, "Email", "email"),
                        defaultCommunicationMethod: this.propertyDataAlternateColumnName(item.attributes, "DefaultCommunicationMethod", "defaultCommunicationMethod"),
                        postalAddress: this.propertyDataAlternateColumnName(item.attributes, "PostalAddress", "postalAddress"),
                        designation: this.propertyDataAlternateColumnName(item.attributes, "Designation", "designation"),
                        organisation: this.propertyDataAlternateColumnName(item.attributes, "Organisation", "organisation"),
                        streetAddress: this.propertyDataAlternateColumnName(item.attributes, "StreetAddress", "streetAddress"),
                        homePhone: this.propertyDataAlternateColumnName(item.attributes, "Homephone", "homephone"),
                        idNumber: this.propertyDataAlternateColumnName(item.attributes, "IDNumber", "iDNumber"),
                        organisationRegistrationNumber: this.propertyDataAlternateColumnName(item.attributes, "organisationRegistrationNumber", "OrganisationRegistrationNumber"),
                        representative: this.propertyDataAlternateColumnName(item.attributes, "Representative", "representative"),
                        fax: this.propertyDataAlternateColumnName(item.attributes, "Fax", "fax"),
                        cellphone: this.propertyDataAlternateColumnName(item.attributes, "Cellphone", "cellphone"),
                        streetSuburb: this.propertyDataAlternateColumnName(item.attributes, "StreetSuburb", "streetSuburb"),
                        streetCity: this.propertyDataAlternateColumnName(item.attributes, "StreetCity", "streetCity"),
                        streetProvince: this.propertyDataAlternateColumnName(item.attributes, "StreetProvince", "streetProvince"),
                        streetCode: this.propertyDataAlternateColumnName(item.attributes, "StreetCode", "streetCode"),
                        postalSuburb: this.propertyDataAlternateColumnName(item.attributes, "PostalSuburb", "postalSuburb"),
                        postalCity: this.propertyDataAlternateColumnName(item.attributes, "PostalCity", "postalCity"),
                        postalProvince: this.propertyDataAlternateColumnName(item.attributes, "PostalProvince", "postalProvince"),
                        postalCode: this.propertyDataAlternateColumnName(item.attributes, "PostalCode", "postalCode"),
                        postalCountry: this.propertyDataAlternateColumnName(item.attributes, "PostalCountry", "postalCountry"),
                        streetCountry: this.propertyDataAlternateColumnName(item.attributes, "StreetCountry", "streetCountry"),
                        professionalBody: this.propertyDataAlternateColumnName(item.attributes, "ProfessionalBody", "professionalBody"),
                        professionalBodyRegNum: this.propertyDataAlternateColumnName(item.attributes, "professionalBodyRegistrationNumber", "ProfessionalBodyRegistrationNumber"),
                        groups: this.ownerGroups
                    };
                    propertyOwners.push(newOwner);
                }
                catch (err) {
                    this.appController.showMessage("Error building the owner", AlertType.Error);
                }
            }
        });
        return propertyOwners;
    }
    loadBlock(symbolsAndLayers, blockType) {
        const blockShape = this.propertiesForm.get(blockType).value;
        if (blockShape) {
            const blockGeom = new Polygon(blockShape);
            this.mapComponent.addGeometriesOnMap(([GeometryUtils.mapGeometryToDTO(blockGeom)]), symbolsAndLayers.layerName, true, false, symbolsAndLayers.symbols);
        }
    }
    reshapingBlock(symbolsAndLayers, blockType) {
        const blockShape = this.propertiesForm.get(blockType).value;
        if (blockShape) {
            const blockGeom = new Polygon(blockShape);
            this.mapComponent.addGeometriesOnMap(([GeometryUtils.mapGeometryToDTO(blockGeom)]), this.drawToolLayer, true, false, symbolsAndLayers.symbols);
        }
    }
    syncMapGeometries(updateGeometry, loadBothBlocks) {
        this.properties.clear();
        let symbolsAndLayers;
        const geomArray = [];
        let properties = [];
        const propertiesControl = this.propertiesForm.get("dataSource").value;
        if (propertiesControl) {
            properties = propertiesControl.getValue();
        }
        properties.forEach(prop => {
            const newProperty = new FormGroup({
                // id: new FormControl(prop.id),
                sgCode: new FormControl(prop.sgCode, [Validators.required]),
                address: new FormControl(prop.address),
                allotment: new FormControl(prop.allotment),
                zoning: new FormControl(prop.zoning),
                erfSize: new FormControl(prop.erfSize),
                farmNumber: new FormControl(prop.farmNumber, [Validators.required]),
                erfNumber: new FormControl(prop.erfNumber, [Validators.required]),
                subdivision: new FormControl(prop.subdivision),
                unitNumber: new FormControl(prop.unitNumber?.toString()),
                description: new FormControl(prop.description),
                owners: new FormControl(prop.owners, [Validators.required]),
                deleted: new FormControl(prop.deleted),
                shape: new FormControl(prop.shape, [Validators.required]),
                wkid: new FormControl(prop.wkid, [Validators.required]),
            });
            if (prop.erfNumber && prop.erfNumber.trim()) {
                newProperty.get("farmNumber").clearValidators();
                newProperty.get("farmNumber").updateValueAndValidity();
            }
            if (prop.farmNumber && prop.farmNumber.trim()) {
                newProperty.get("erfNumber").clearValidators();
                newProperty.get("erfNumber").updateValueAndValidity();
            }
            if (updateGeometry) {
                const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
                geomArray.push(GeometryUtils.mapGeometryToDTO(geom));
            }
            this.properties.push(newProperty);
        });
        if (updateGeometry && this.isMapLoaded) {
            if (loadBothBlocks) {
                this.drawingSalesArea = false;
                this.drawingBlock = true;
                symbolsAndLayers = this.selectSymbolsAndLayers();
                this.loadBlock(symbolsAndLayers, "shape");
                this.drawingSalesArea = true;
                this.drawingBlock = false;
                symbolsAndLayers = this.selectSymbolsAndLayers();
                this.loadBlock(symbolsAndLayers, "salesAreaShape");
                this.drawingSalesArea = false;
                this.drawingBlock = false;
                this.mapComponent.addGeometriesOnMap((geomArray), this.propertyLayerName, true, false);
            }
            else {
                if (this.reshaping) {
                    if (this.drawingBlock) {
                        symbolsAndLayers = this.selectSymbolsAndLayers();
                        this.reshapingBlock(symbolsAndLayers, "shape");
                        this.mapComponent.addGeometriesOnMap((geomArray), symbolsAndLayers.propertyLayerName, true, false);
                    }
                    else if (this.drawingSalesArea) {
                        symbolsAndLayers = this.selectSymbolsAndLayers();
                        this.reshapingBlock(symbolsAndLayers, "salesAreaShape");
                        this.mapComponent.addGeometriesOnMap((geomArray), symbolsAndLayers.propertyLayerName, true, false);
                    }
                }
                else {
                    if (this.drawingBlock) {
                        symbolsAndLayers = this.selectSymbolsAndLayers();
                        this.loadBlock(symbolsAndLayers, "shape");
                        this.mapComponent.addGeometriesOnMap((geomArray), symbolsAndLayers.propertyLayerName, true, false);
                    }
                    else if (this.drawingSalesArea) {
                        symbolsAndLayers = this.selectSymbolsAndLayers();
                        this.loadBlock(symbolsAndLayers, "salesAreaShape");
                        this.mapComponent.addGeometriesOnMap((geomArray), symbolsAndLayers.propertyLayerName, true, false);
                    }
                }
            }
        }
        this.numProps = this.properties.length;
    }
    onButtonRemoveClicked($event) {
        this.removeProperties();
    }
    updateProperty($event) {
        this.updatePropertyDetailsValidation();
        this.propertyDetailsForm.markAllAsTouched();
        this.changeDetectorRefs.detectChanges();
        const tableDataSource = this.propertiesForm.get("dataSource").value;
        const itemsAlreadyOnTable = tableDataSource.getValue();
        const editIndex = this.propertyDetailsForm.get("editIndex").value;
        const idx = itemsAlreadyOnTable.findIndex(x => x.id === editIndex);
        const owners = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.OWNER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].sgCode = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.SG_CODE_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].allotment = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.AREA_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].zoning = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ZONING_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].address = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ADDRESS_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].description = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.DESCRIPTION_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].erfNumber = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ERF_NUMBER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].farmNumber = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.FARM_NUMBER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].subdivision = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.PORTION_NUMBER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].unitNumber = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.UNIT_NUMBER_CONTROL_NAME).value;
        itemsAlreadyOnTable[idx].erfSize = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ERF_SIZE_CONTROL_NAME).value;
        if (owners && Object.prototype.hasOwnProperty.call(owners, "recipients")) {
            itemsAlreadyOnTable[idx].owners = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.OWNER_CONTROL_NAME).value["recipients"];
        }
        else {
            itemsAlreadyOnTable[idx].owners = [];
        }
        const allItems = [...itemsAlreadyOnTable];
        tableDataSource.next(allItems);
        this.changeDetectorRefs.markForCheck();
        this.changeDetectorRefs.detectChanges();
        this.syncMapGeometries(false, false);
    }
    showPropertyDetails() {
        const selectedProperty = this.propertiesForm.get("tableSelection").value[0];
        this.propertyToEdit = true;
        this.propertyDetailsForm.get("editIndex").setValue(selectedProperty.id);
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.SG_CODE_CONTROL_NAME).setValue(selectedProperty.sgCode);
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.AREA_CONTROL_NAME).setValue(selectedProperty.allotment);
        if (selectedProperty.zoning) {
            this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ZONING_CONTROL_NAME).setValue(selectedProperty.zoning);
        }
        else {
            this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ZONING_CONTROL_NAME).setValue(null);
        }
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.PORTION_NUMBER_CONTROL_NAME).setValue(selectedProperty.subdivision);
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ADDRESS_CONTROL_NAME).setValue(selectedProperty.address);
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.DESCRIPTION_CONTROL_NAME).setValue(selectedProperty.description);
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ERF_NUMBER_CONTROL_NAME).setValue(selectedProperty.erfNumber);
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.FARM_NUMBER_CONTROL_NAME).setValue(selectedProperty.farmNumber);
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.UNIT_NUMBER_CONTROL_NAME).setValue(selectedProperty.unitNumber);
        this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.ERF_SIZE_CONTROL_NAME).setValue(selectedProperty.erfSize);
        const ownerControl = this.propertyDetailsForm.get(EditPropertyDetailsPvConstants.OWNER_CONTROL_NAME);
        ownerControl.reset();
        this.changeDetectorRefs.detectChanges();
        if (selectedProperty.owners && selectedProperty.owners.length > 0) {
            this.recipientListService.setRecipients(selectedProperty.owners, true, ownerControl);
        }
    }
    removeProperties() {
        const itemsForDeletion = this.propertiesForm.get("tableSelection").value;
        const tableSource = this.propertiesForm.get("dataSource").value;
        if (itemsForDeletion.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const deletedItem = itemsForDeletion;
        let index = 0;
        const itemsAlreadyOnTable = tableSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === deletedItem) {
                index = i;
            }
        }
        const options = {
            size: "sm",
            centered: true,
            keyboard: false,
            backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removePropertyContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = index;
        dialogRef.result.then((deleteSelected) => {
            if (deleteSelected !== undefined && deleteSelected !== null) {
                for (let i = 0, len = itemsForDeletion.length; i < len; i++) {
                    const ItemIndex = itemsAlreadyOnTable.findIndex(b => b.id === itemsForDeletion[i].id);
                    itemsAlreadyOnTable.splice(ItemIndex, 1);
                }
                const allItems = [...itemsAlreadyOnTable];
                tableSource.next(allItems);
                this.propertiesForm.get("tableSelection").setValue([]);
                this.propertyToEdit = false;
                this.changeDetectorRefs.markForCheck();
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries(true, false);
            }
        }).catch((res) => {
        });
    }
    setShowMap() {
        const valuationMethod = this.aflaModuleStrategyService.form.get("detailsForm").get("valuationBlockMethodSelect").value;
        const propertyType = this.aflaModuleStrategyService.form.get("detailsForm").get("propertyTypeSelect").value;
        valuationMethod && valuationMethod.hasOwnProperty("value") ? this.valuationMethod = valuationMethod.value : this.valuationMethod = valuationMethod;
        propertyType && propertyType.hasOwnProperty("value") ? this.propertyType = propertyType.value : this.propertyType = propertyType;
        if (!this.valuationMethod || !this.propertyType) {
            this.showMap = false;
        }
        else {
            this.showMap = true;
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    clearSketchGraphic() {
        this.mapComponent.removeGraphicsFromMap(this.mapTools.sketchGraphicsLayer.id);
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = ValuationPropertyHeadingLookup;
    }
    importParameters(event) {
        if (event.currentTarget.checked) {
            this.propertiesForm.get("importParentAttributesParameters").setValue(true);
        }
    }
    resetBlockClicked() {
        this.propertiesForm.get(CreateApplicationLocationPvConstants.SALES_AREA_SHAPE).reset();
        this.propertiesForm.setControl(CreateApplicationLocationPvConstants.SALES_AREA_SHAPE, new FormControl(this.propertiesForm.get(CreateApplicationLocationPvConstants.VALUATION_BLOCK_SHAPE).value));
        this.drawingSalesArea = true;
        this.removeExistingProperties();
        this.drawingSalesArea = false;
        this.syncMapGeometries(true, true);
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: MapService },
        { type: MapTools },
        { type: NgbModal },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: false },] }]
    };
};
CreateApplicationLocationPvComponent = __decorate([
    Component({
        selector: "app-create-application-location-pv",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationPvComponent);
export { CreateApplicationLocationPvComponent };
